import countries from '../data/territories.json';

export const TERRITORY_COUNTRIES = countries;
export const normalizeTerritoryName = (value = '') => String(value || '')
  .trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase()
  .replace(/^(?:PROVINCIA|ESTADO|DEPARTAMENTO|REGION)\s+(?:DE\s+|DEL\s+)?/, '')
  .replace(/\s+/g, ' ').trim();

export const getTerritoryCountry = (value) => {
  const key = normalizeTerritoryName(value);
  return countries.find((country) => [country.code, country.iso2, country.name, ...country.aliases]
    .some((name) => normalizeTerritoryName(name) === key)) || null;
};

export const getTerritoryDivision = (country, value) => {
  const key = normalizeTerritoryName(value);
  return country?.divisions.find((division) => [division.code, division.name, ...division.aliases]
    .some((name) => normalizeTerritoryName(name) === key)) || null;
};

// Infer missing countries only from unambiguous names. Santa Cruz and Río Negro
// must not silently be assigned to Argentina when the country is unknown.
export const resolveTerritory = (caso = {}) => {
  let country = getTerritoryCountry(caso.pais);
  if (!String(caso.pais || '').trim()) {
    const candidates = countries.filter((item) => getTerritoryDivision(item, caso.provincia));
    if (candidates.length === 1) [country] = candidates;
  }
  const division = getTerritoryDivision(country, caso.provincia);
  const countryCode = country?.code || normalizeTerritoryName(caso.pais) || 'UNKNOWN';
  const divisionCode = division?.code || `UNKNOWN:${normalizeTerritoryName(caso.provincia)}`;
  return {
    id: `${countryCode}::${divisionCode}`,
    pais: country?.name || String(caso.pais || '').trim() || 'Sin país',
    pais_codigo: countryCode,
    provincia: division?.name || String(caso.provincia || '').trim() || 'Sin división',
    provincia_codigo: division?.code || null,
  };
};

export const getProvinceFeatureTerritory = (feature) => {
  const props = feature?.properties || {};
  const country = getTerritoryCountry(props.pais_codigo || 'ARG');
  const division = getTerritoryDivision(country, props.provincia_codigo || props.nombre || props.NIVEL_9 || props.provincia);
  return division ? resolveTerritory({ pais: country.name, provincia: division.name }) : null;
};
